<template>
    <div class="new-blind-box-view"
        :style="{backgroundImage: 'url(' + activityPictureUrl + ')'}">
        <!-- 新盲盒抽奖区 -->
        <div class="lottery-area">
            <!-- 获奖名单轮播--上方 -->
            <winner-list v-if="isShowScroll && winnerList.length"
              :winnerList="winnerList"
              :activityObj="activityObj"></winner-list>
            <img class="box-img"
                :style="{'margin': isShowScroll && winnerList.length ? 'calc(25.8vh - 58px) auto 0' : '25.8vh auto 0'}"
                :src="drawWheelUrl">
            <!-- 积分抽奖 -->
            <div v-if="drawType === BWC.DrawType.PointDraw && activityStatus === BWC.ActivityStatus.running"
                class="integral">
                <div>{{ pointDrawText }}</div>
            </div>
            <!-- 为初始抽奖或订单抽奖，且活动为进行中 -->
            <div v-if="isShowRemainChances"
                class="step-times">
                <div v-if="tips">{{ tips }}</div>
                <div v-else>剩余抽奖次数{{ participateTimes > 99 ? '99+' : participateTimes }}次</div>
            </div>
            <!-- 需要登录 -->
            <div v-if="pointDrawFlag && loginType === BWC.LoginType.Alipay"
                class="button"
                :style="{'background':buttonColor,'color':buttonTextColor,'box-shadow': `0px 0px 8px 0px ${buttonColor}`}">
                <div class="login-p">登录荣耀会员获得抽奖机会</div>
                <div class="go-login"
                    @click="goHiHonorMiniProgram('index')"></div>
            </div>
            <!-- 登入成功或无需登录，抽奖按钮 -->
            <div v-else
                class="button"
                :style="drawBtnStyle"
                @click="lotteryHandler">
                {{ pointerText }}
            </div>
        </div>
        <!-- 中奖查询区域，涉及跳转小程序 -->
        <div class="query-prize-records"
          :style="{ 
            'color': activityObj.extendConfig.awardListButtonColor || '#256fff',
            'justify-content': isShowScroll ? 'center' : 'space-between' }"
        >
            <!-- 在小程序内或登录方式为支付宝 -->
            <div>
              <div v-if="isInMiniProgram || loginType === BWC.LoginType.Alipay"
                  class="winning-inquiry"
                  @click="winningInquiry">
                  中奖查询
              </div>
              <!-- 不在小程序内，且登录方式为微信 -->
              <div v-if="!isInMiniProgram && loginType === BWC.LoginType.Wechat"
                  class="winning-inquiry">
                  中奖查询
                  <div class="content-winningPrize-buttom-wechat">
                      <!-- 体验店 -->
                      <div class="wxOpenLaunchWeapp"
                          v-html="wxOpenLaunchWeappHiHonor"></div>
                  </div>
              </div>
            </div>
            <div v-if="!isShowScroll" class="winning-inquiry" @click="goWinnerList">中奖名单</div>
        </div>
        <!-- 活动奖品和规则弹窗按钮区 -->
        <div class="activity-prizes-and-rules"
            @click="viewPrizesAndRules">
            <div class="triangle">&#9650;</div>
            点击查看活动奖品和规则
        </div>
        <!-- 活动奖品和规则弹窗 -->
        <prizes-and-rules-popup :popupVisible="popupVisible"
            :prizeList="prizeList"
            :ruleDesc="ruleDesci"
            :myRecord="myRecord"
            @viewPrizes="viewPrizes"
            @closePopup="unViewPrizesAndRules"></prizes-and-rules-popup>
    </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll';
import { BigWheelConstants as BWC } from '../../../common/global-variable';
import { config as configEnv } from '../../../../../../../commons/config.js';
import prizesAndRulesPopup from './prizes-and-rules-popup.vue';
import winnerList from '../../../components/winner-list.vue';
import { config } from '@/api/config.js';
export default {
  name: 'NewBlindBoxView',
  components: { vueSeamlessScroll, prizesAndRulesPopup,winnerList },
  props: {
    // 接口queryActivityBigWheelActivityDetailH5返回的活动信息
    activityInfoObj: {
      type: Object,
      default: {},
    },
    // 中奖者名单
    winnerList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    // 获取抽奖次数方式
    drawType: {
      type: String,
      default: '',
    },
    // 每次抽奖需要积分数
    drawPointConsumption: {
      type: Number,
      default: 10,
    },
    // 剩余积分
    balancePoints: {
      type: String,
      default: '',
    },
    // 还可抽奖次数
    participateTimes: {
      type: Number,
      default: 0,
    },
    // 登录类型
    loginType: {
      type: String,
      default: '',
    },
    // 积分抽奖标识，false -> 可正常抽奖，true -> 积分抽奖，但是条件不满足，比如当前用户不是会员
    pointDrawFlag: {
      type: Boolean,
      default: false,
    },
    isInMiniProgram: {
      type: Boolean,
      default: false,
    },
    // 我的中奖记录
    myRecord: {
      type: Array,
      default: [],
    },
    // 抽奖机会已用完展示文案
    tips: {
      type: String,
      default: '',
    },
    // 活动规则
    ruleDesci: {
      type: String,
      default: '',
    },
    activityObj: {
      type: Object,
      default: {}
    },
    // 用户的抽奖状态
    drawStatus: {
      type: String,
      default: ''
    },
    // 页面展示文案
    pageDisplayContent: {
      type: String,
      default: ''
    },
    // 弹窗提示语
    tipsMessage: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      BWC: BWC,
      classOptionUp: {
        limitMoveNum: 2,
        direction: 1,
        step: 0.3,
      },
      wxOpenLaunchWeappHiHonor: '',
      env: configEnv.env === 'pro' ? 'release' : 'trial',
      popupVisible: false,
      hiHonorWxAppId:config.otherConfig.hiHonorWxAppId,
    };
  },
  computed: {
    // 是否显示滚动栏
    isShowScroll(){
      if(this.activityObj.prizeWinningScrollFlag === BWC.prizeWinningScrollFlag.display){
        return true;
      }else{
        return false;
      }
    },
    // 活动图片
    activityPictureUrl() {
      if (this.activityInfoObj.activityPictureUrl) {
        return this.$utils.getImageUrl(JSON.parse(this.activityInfoObj.activityPictureUrl).file);
      } else {
        return '';
      }
    },
    // 活动状态
    activityStatus() {
      if (this.activityInfoObj.activityStatus) {
        return this.activityInfoObj.activityStatus;
      } else {
        return '';
      }
    },
    // 按钮颜色
    buttonColor() {
      if (this.activityInfoObj.activityConfig && this.activityInfoObj.activityConfig.buttonColor) {
        return this.activityInfoObj.activityConfig.buttonColor;
      } else {
        return '';
      }
    },
    // 按钮文本颜色
    buttonTextColor() {
      if (this.activityInfoObj.activityConfig && this.activityInfoObj.activityConfig.buttonTextColor) {
        return this.activityInfoObj.activityConfig.buttonTextColor;
      } else {
        return '';
      }
    },
    // 抽奖盒子图片URL
    drawWheelUrl() {
      if (this.activityInfoObj.drawWheelUrl) {
        return this.$utils.getImageUrl(JSON.parse(this.activityInfoObj.drawWheelUrl).file);
      } else {
        return '';
      }
    },
    // 是否显示剩余抽奖次数
    isShowRemainChances() {
      // 当前为初始抽奖或订单抽奖，且活动为进行中
      return (
        (this.drawType === BWC.DrawType.InitDraw || this.drawType === BWC.DrawType.OrderDraw) &&
        this.activityStatus === BWC.ActivityStatus.running
      );
    },
    // 奖品池
    prizeList() {
      const tmp = [];
      if (this.activityInfoObj.bigWheelRewardList) {
        this.activityInfoObj.bigWheelRewardList.forEach((data) => {
          const item = {
            imgUrl: data.imgUrl,
            goodsName: data.goodsName,
          };
          if (data.goodsType !== BWC.GoodsType.noAward) {
            tmp.push(item);
          }
        });
      }
      return tmp;
    },
    drawBtnStyle() {
      let bgColor = this.buttonColor;
      if (this.activityStatus !== BWC.ActivityStatus.running || this.drawStatus === BWC.status.exceedDailyTimes || this.drawStatus === BWC.status.exceedTotalTimes) {
        bgColor = '#E0E0E0';
      }
      return {
        background: bgColor,
        color: this.buttonTextColor,
        'box-shadow': `0px 0px 8px 0px ${bgColor}`,
        'margin-top': this.activityStatus === BWC.ActivityStatus.running ? '2.5vh' : '10vh'
      };
    },
    // 积分抽奖文案
    pointDrawText(){
      if (this.drawStatus === BWC.status.exceedDailyTimes || this.drawStatus === BWC.status.exceedTotalTimes) {
        return this.pageDisplayContent;
      } else {
        return this.drawPointConsumption + '积分/次\n您剩余积分：' + this.balancePoints;
      }
    },
    // 抽奖按钮显示的文案
    pointerText() {
      switch (this.activityStatus) {
        case BWC.ActivityStatus.notStarted:
          return '活动未开始';
        case BWC.ActivityStatus.paused:
          return '活动已暂停';
        case BWC.ActivityStatus.finished:
          return '活动已结束';
        case BWC.ActivityStatus.running:
          return '拆盲盒'
        default:
          return '';
      }
    },
  },
  created() {
    if (!this.isInMiniProgram) {
      this.wxOpenLaunchWeappHiHonor = `<wx-open-launch-weapp id="launch-btn" env-version="${this.env}" username="${this.hiHonorWxAppId}" path="subpackages/my/pages/rewardQuery/reward-query"><template><style>.btn { width: 1000px;height: 300px; opacity: 0;}</style><button class="btn">打开小程序</button> </template> </wx-open-launch-weapp>`;
    }
  },
  methods: {
    initData() {},
    // 跳转到中奖者名单页面
    goWinnerList() {
      this.$emit('goWinnerList');
    },
    // 跳转到Hi荣耀小程序
    goHiHonorMiniProgram(index) {
      this.$emit('goHiHonorMiniProgram', index);
    },
    // 抽奖，并做结果展示
    lotteryHandler() {
      this.$emit('startLottery');
    },
    // 小程序内跳转查询中奖记录
    winningInquiry() {
      this.$emit('winningInquiry');
    },
    // 打开活动奖品和规则弹窗
    viewPrizesAndRules() {
      this.popupVisible = true;
    },
    // 关闭活动奖品和规则弹窗
    unViewPrizesAndRules() {
      this.popupVisible = false;
    },
    viewPrizes(item) {
      this.$emit('viewPrizes', item);
    },
  },
};
</script>
<style lang="scss" scoped>
.new-blind-box-view {
  height: 100vh;
  width: 100vw;
  background-position: center center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  background-color: #fff;
  .marquee-up {
    background-color: rgb(242, 247, 255);
    height: 4.7vh;
    width: 100vw;
    margin: 0 auto;
    overflow: hidden;
    .carousel {
      display: flex;
      align-items: center;
      // justify-content: space-around;
      height: 4.7vh;
      .more {
        display: flex;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .more-first {
        margin-left: 5%;
      }
      .more-two {
        flex: 1;
      }
      .auto-text {
        font-size: 14px;
        color: #181818;
        font-weight: 400;
        display: flex;
      }
      .name-text {
        font-size: 14px;
        font-weight: 400;
      }
      .name-text-first {
        width: 62px;
      }
      .name-text-two {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }

  .lottery-area {
    width: 100%;
    .box-img {
      width: 61.3%;
      height: 39vh;
      display: block;
      animation: bounce-down 1.6s linear infinite;
    }
    .integral {
      margin-top: 3.3vh;
      font-size: 14px;
      color: #181818;
      text-align: center;
      font-weight: 400;
      // 使得\n可以正常换行
      white-space: pre-wrap;
    }
    .step-times {
      font-size: 19px;
      font-weight: 500;
      text-align: center;
      margin-top: 3.3vh;
    }
    .button {
      position: relative;
      background-size: cover;
      width: 65%;
      font-size: 16px;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
      line-height: 47px;
      margin: 2.5vh auto 0;
      border-radius: 24px;
      .login-p {
        position: relative;
      }
      .go-login {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
      }
    }
    .button-mt {
      margin-top: 10.6vh;
    }
  }

  .query-prize-records {
    position: absolute;
    bottom: 9.9vh;
    display: flex;
    justify-content: space-between;
    width: 40vw;
    left: 50%;
    transform: translateX(-50%);
    .winning-inquiry {
      position: relative;
      font-size: 14px;
      text-align: center;
      font-weight: 400;
      text-decoration: underline;
      .content-winningPrize-buttom-wechat {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
      }
    }
  }

  .activity-prizes-and-rules {
    position: absolute;
    bottom: 1.4vh;
    font-size: 14px;
    color: #181818;
    text-align: center;
    font-weight: 400;
  }
}
@keyframes bounce-down {
  25% {
    -webkit-transform: translateY(-4px);
  }
  50%,
  100% {
    -webkit-transform: translateY(0);
  }
  75% {
    -webkit-transform: translateY(4px);
  }
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/lucky-draw/lucky-draw-page/new-blind-box/components/new-blind-box-view.vue